import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { mdsDashboardNewTreatment } from 'src/config';
import { paths } from 'src/paths';
import { usePermission, Permissions } from 'src/rbac';

/**
 * BRK-1850: route-level guard for all MDS Dashboard pages. Direct URL entry
 * must be unreachable when the mds-dashboard-new facility flag is off OR the
 * user lacks the 'Read MDS Dashboard' permission — same invisibility rule the
 * backend enforces (every /api/document/mds-dashboard endpoint 404s when the
 * flag is off). Renders nothing while the Split client is still loading so a
 * slow flag fetch doesn't flash a redirect.
 */
const MdsDashboardGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMdsDashboardEnabled] = useFeatureToggleWhenReady(
    mdsDashboardNewTreatment,
    'FACILITY'
  );
  const canReadMdsDashboard = usePermission(Permissions.READ_MDS_DASHBOARD);

  if (isMdsDashboardEnabled === null) {
    return null;
  }
  if (!isMdsDashboardEnabled || !canReadMdsDashboard) {
    // paths.index is always routable; /dashboard is itself permission-gated
    return <Navigate to={paths.index}
replace />;
  }
  return <>{children}</>;
};

export default MdsDashboardGuard;
